import { Badge } from '@/components/ui/daisy';
import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

type AnswerContainerProps = PropsWithChildren<{
  isCorrect?: boolean;
  isEditing: boolean;
  isMedia?: boolean;
  className?: string;
}>;

export default function AnswerContainer({
  children,
  isCorrect,
  isEditing,
  isMedia,
  className,
}: AnswerContainerProps) {
  const color =
    isCorrect === undefined ? 'neutral' : isCorrect ? 'success' : 'error';

  const borderColorIsCorrect = isCorrect
    ? 'border-success/20'
    : 'border-error/20';

  const borderClass = twMerge(
    'border-base-300',
    isCorrect === undefined ? 'border-base-300' : borderColorIsCorrect,
  );

  return (
    <Badge
      color={color}
      size="lg"
      variant="soft"
      className={twMerge(
        'flex w-full items-center justify-between px-4 min-h-13 border border-base-300',
        borderClass,
        (isMedia || isEditing) && 'h-fit py-2',
        className,
      )}
    >
      {children}
    </Badge>
  );
}
